export enum ProposalsTrackStatusEnum {
    'AGUARDANDO_ENVIO_AUTOMATICO' = 1,
    'FALHA_AO_ENVIAR_AUTOMATICAMENTE' = 2,
    'PROPOSTA_EM_DIGITACAO' = 3,
    'PROPOSTA_ENVIADA_A_FINANCEIRA' = 4,
    'PROPOSTA_PAGA_AO_CLIENTE' = 5,
    'PROPOSTA_RECUSADA_PELA_FINANCEIRA' = 6,
    'CANCELADA_PELO_DIGITADOR' = 7
}